import Typography from "@mui/material/Typography";
import { Chip, Grow } from "@mui/material";
import * as s from "./styles";
import { Star } from "@mui/icons-material";
import { Promotion } from "../../@data";
import { useAuth } from "../../contexts";

interface IPromotionCard {
  promotion: Promotion;
  isVisitant: boolean;
}

export default function PromotionCard(props: IPromotionCard) {
  const { promotion, isVisitant } = props;
  const { client } = useAuth();

  const dontHaveSuficientLevel = client.level < promotion.level;

  return (
    <Grow in timeout={800}>
      <s.CardContainer isVisitant={isVisitant || dontHaveSuficientLevel}>
        <section>
          {isVisitant ? (
            <Chip
              label="APENAS PARA CLIENTES"
              sx={{
                mb: "0.5rem",
                fontSize: "0.7rem",
                fontWeight: "bold",
                color: "background.paper",
                backgroundColor: "gray",
                mr: "auto",
              }}
            />
          ) : dontHaveSuficientLevel ? (
            <Chip
              label="BLOQUEADO PARA SEU NÍVEL"
              sx={{
                mb: "0.5rem",
                fontSize: "0.7rem",
                fontWeight: "bold",
                color: "background.paper",
                backgroundColor: "gray",
                mr: "auto",
              }}
            />
          ) : (
            promotion.flashPromotion && (
              <Chip
                label="PROMOÇÃO RELÂMPAGO"
                sx={{
                  mb: "0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                  mr: "auto",
                }}
                color="primary"
              />
            )
          )}
          <Typography variant="body2" component="p" fontWeight={300}>
            {promotion.title}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            fontWeight={500}
            sx={{ m: "0.3rem 0" }}
          >
            {promotion.description}
          </Typography>
          <s.LevelContainer>
            {[...Array(promotion.level)].map((_, index) => (
              <Star
                key={`${promotion.title}${index}`}
                color="primary"
                fontSize="inherit"
                sx={{ mt: "-2.5px" }}
              />
            ))}
            <Typography
              variant="caption"
              fontWeight={600}
              sx={{ m: "0 0.2rem" }}
            >
              Nível {promotion.level}
            </Typography>
            <Typography variant="caption" color="gray">
              {` • ${promotion.place}`}
            </Typography>
          </s.LevelContainer>
        </section>
        {promotion.imageUrl && (
          <img src={promotion.imageUrl} alt={`Imagem da ${promotion.title}`} />
        )}
      </s.CardContainer>
    </Grow>
  );
}
